import { BaseTableEntities } from '@/types'

const infraTables: BaseTableEntities = {
  vmPayload: [
    {
      value: 'name',
      text: '',
      prependIcon: (value, rootValue) => !rootValue.lock
        ? (rootValue.status ? `mdi-television${rootValue.status === 'RUNNING' ? '-play' : ''}` : rootValue.status)
        : 'mdi-monitor-lock'
    },
    {
      value: 'lock',
      text: '',
      hidden: true
    },
    {
      value: 'accessLevel',
      text: '',
      hidden: true
    },
    {
      value: 'cronLastDatetime',
      text: '',
      auditing: true
    },
    {
      value: 'cronNextDatetime',
      text: '',
      auditing: true
    },
    {
      value: 'cronNextCommand',
      text: '',
      hidden: true
    },
    {
      value: 'cron',
      text: '',
      auditing: true
    },
    {
      value: 'id',
      text: '',
      auditing: true
    }
  ]
}

export default infraTables